import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  Paper,
  TextField,
  Typography,
  Tooltip,
} from '@mui/material';

const EditState = () => {
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [stateName, setStateName] = useState('');
  const [countryId, setCountryId] = useState('');
  const { stateId } = useParams();
  const navigate = useNavigate();

  // Static data
  const countryData = [
    { countryId: 1, countryName: 'United States' },
    { countryId: 2, countryName: 'Canada' },
    { countryId: 3, countryName: 'United Kingdom' },
    { countryId: 4, countryName: 'Australia' },
    { countryId: 5, countryName: 'Germany' },
  ];

  const stateData = [
    { stateId: '1', stateName: 'California', countryId: 1 },
    { stateId: '2', stateName: 'Texas', countryId: 1 },
    { stateId: '3', stateName: 'Ontario', countryId: 2 },
    { stateId: '4', stateName: 'Quebec', countryId: 2 },
    { stateId: '5', stateName: 'New South Wales', countryId: 4 },
  ];

  // Set initial values based on stateId
  useState(() => {
    const stateToEdit = stateData.find(state => state.stateId === stateId);
    if (stateToEdit) {
      setStateName(stateToEdit.stateName);
      setCountryId(stateToEdit.countryId);
    }
  }, [stateId]);

  const handleUpdate = () => {
    // Simulate API call with timeout
    setTimeout(() => {
      console.log('State updated:', { stateName, countryId });
      setShowSuccessModal(true);
    }, 500);
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minHeight: '50vh',
      }}
    >
      <Box
        sx={{
          backgroundColor: 'rgba(2, 78, 101, 1)', // dark navy blue
          padding: '12px 16px',
          boxShadow: 3,
          borderRadius: '4px 4px 0 0',
          margin: '2px auto',
          width: "100%",
        }}
      >
        <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
          Edit State
        </Typography>
      </Box>

      <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6, backgroundColor: '#f8fdfeff' }}>
        <div>
          <FormControl fullWidth sx={{ my: 2 }}>
            <InputLabel htmlFor="country">Country:</InputLabel>
            <Select
              id="country"
              value={countryId}
              label="Country"
              onChange={(e) => setCountryId(e.target.value)}
            >
              {countryData.map((countryItem) => (
                <MenuItem key={countryItem.countryId} value={countryItem.countryId}>
                  {countryItem.countryName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            fullWidth
            id="stateName"
            label="State Name"
            variant="outlined"
            value={stateName}
            onChange={(e) => setStateName(e.target.value)}
            sx={{ mb: 3 }}
          />
          <Tooltip title={!countryId ? "Select Country" : !stateName ? "Enter State Name" : ""} arrow>
            <span>
              <Button
                variant="contained"
                onClick={handleUpdate}
                sx={{
                  mr: 2,
                  backgroundColor: '#127498ff',
                  '&:hover': { backgroundColor: '#116280ff' }
                }}
                disabled={!stateName || !countryId}
              >
                UPDATE
              </Button>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            color="error"
            onClick={handleCancel}
          >
            CANCEL
          </Button>
        </div>
      </Paper>

      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: 'background.paper',
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          {/* Header */}
          <Box sx={{ backgroundColor: '#0B1F40', padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: '#fff' }}>
              State Updated ✅
            </Typography>
          </Box>

          {/* Content */}
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              State Updated Successfully
            </Typography>

            {/* Buttons */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1); // go back after closing modal
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Container>
  );
};

export default EditState;